import { container, title } from "assets/jss/material-kit-react.js";

import imagesStyle from "assets/jss/material-kit-react/imagesStyles.js";

const workPageStyle = {
  container: {
    ...container,
    position: "relative",
    backgroundColor: "transparent",
    "& p": {
      fontSize: "18px",
      lineHeight: "28px",
      fontWeight: "100",
    },
    "& img": {
      maxWidth: "100%"
    }
  },
  profile: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      margin: "0 auto",
      transform: "translate3d(0, -50%, 0)"
    }
  },
  description: {
    margin: "1.071rem auto 0",
    maxWidth: "600px",
    color: "#999",
    textAlign: "center !important"
  },
  name: {
    marginTop: "-80px"
  },
  ...imagesStyle,
  main: {
    background: "#EDF8F6",
    position: "relative",
    zIndex: "3",
    paddingTop: "150px",
    "@media (max-width: 768px)": {
      paddingTop: "30px",
    },
  },
  minervaCorp: {
    background: "#EDF4FF",
  },
  egs: {
    background: "#EEF7FD",
  },
  aub: {
    background: "#FFF8FC",
  },
  hcoa: {
    background: "#E4F3F8",
  },
  bsc: {
    background: "#EEF7FD",
  },
  acessa: {
    background: "#EDF8F6",
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    marginBottom: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  navWrapper: {
    margin: "20px auto 50px auto",
    textAlign: "center"
  },
  headerImage: {
    width: "100%",
    "& img": {
      maxWidth: "100%",
      maxHeight: "100%",
      display: "block",
    }
  },
};


export default workPageStyle;
